import React from 'react';

interface TabSectionProps {
    title?: string;
    subline?: string;
    children: React.ReactNode;
}

function TabSection({ title, subline, children }: TabSectionProps) {
    return (
        <div>
            <div className="my-4">
                <h4>{title}</h4>
                <span className="block my-2 text-md text-gray-500">{subline}</span>
            </div>
            {children}
        </div>
    );
}

export default TabSection;
